<template>
  <div>
    <div v-if="loading" class="text-center py-5">
      <div class="spinner-border" role="status"></div>
      <p class="text-muted mt-2 text-xs">Loading KYC report...</p>
    </div>

    <div v-else-if="error" class="text-center py-5 text-danger text-xs">
      {{ error }}
    </div>

    <div v-else-if="report_url">
      <iframe
        :src="report_url"
        width="100%"
        height="700"
      ></iframe>
    </div>

    <!-- Empty state -->
    <div v-else class="text-center text-muted py-5 text-xs">
      No report available
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { VIEW_KYC_REPORT, get_headers } from '@/utils/constants/constants';

export default {
  name: "VerificationReport",

  props: {
    entity_profile_id: { type: Number, required: true },
    service_id: { type: Number, required: true }
  },

  data() {
    return {
      report_url: null,
      loading: false,
      error: null
    };
  },

  watch: {
    entity_profile_id: {
      handler: 'fetch_report',
      immediate: true
    },
    service_id: {
      handler: 'fetch_report',
      immediate: true
    }
  },

  methods: {
    async fetch_report() {
      if (!this.entity_profile_id || !this.service_id) {
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const { data } = await axios.get(VIEW_KYC_REPORT, {
          headers: get_headers(),
          params: {
            entity_profile_id: this.entity_profile_id,
            service_id: this.service_id
          }
        });


        if (data?.url) {
          this.report_url = data.url;
        } else {
          this.error = "KYC PDF report is not available.";
        }

      } catch (err) {
        this.error =
          err.response?.data?.detail ||
          err.response?.data?.message ||
          "Failed to fetch KYC report.";
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>